export default [
  {
    name: 'RevenueFlow',
    path: '/revenue-flow',
    component: () =>
      import(
        /* webpackChunkName: "RevenueFlow" */ '@/views/revenue-flow/index'
      ),
    meta: { title: '我的流水' },
  },
  {
    name: 'RevenueFlow',
    path: '/revenue-flow/week',
    component: () =>
      import(
        /* webpackChunkName: "RevenueFlowChart" */ '@/views/revenue-flow/week'
      ),
    meta: { title: '我的流水' },
  },
  {
    name: 'RevenueFlow',
    path: '/revenue-flow/month',
    component: () =>
      import(
        /* webpackChunkName: "RevenueFlowChart" */ '@/views/revenue-flow/month'
      ),
    meta: { title: '我的流水' },
  },
];
